export default __webpack_public_path__ + "static/media/Tasks.d27f0c70.png";